/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>View entire model</h4>

<p>Zoom to view entire model. With SHIFT rotates to an oblique view.</p>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>F</b>: View all (Fit)</li>
</ul>`;

export default function ViewAllTooltip() {
    return h('div', { innerHTML: body });
}
